export default class ErrorMessagesWithProblemElementId {
    constructor(
        public elementId: string
    ) { }
}